import { render, staticRenderFns } from "./SamplesBrowse.vue?vue&type=template&id=4dabee1e&scoped=true"
import script from "./SamplesBrowse.vue?vue&type=script&lang=js"
export * from "./SamplesBrowse.vue?vue&type=script&lang=js"
import style0 from "./SamplesBrowse.vue?vue&type=style&index=0&id=4dabee1e&prod&lang=css"
import style1 from "./SamplesBrowse.vue?vue&type=style&index=1&id=4dabee1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dabee1e",
  null
  
)

export default component.exports